import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
export interface AlertDialogAction {
  label: string;
  index: string;
  color: string;
}

export interface AlertDialogConfig {
  allowAutoClose: boolean;
}

@UntilDestroy()
@Component({
  selector: 'app-alert-dialog',
  templateUrl: 'alert-dialog.component.html',
})
export class AlertDialogComponent implements OnInit {
  public title: string = '';
  public body: string = '';
  public actions: AlertDialogAction[] = [];

  public config: AlertDialogConfig = {
    allowAutoClose: false,
  };
  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    if (this.data) {
      if (this.data.title != undefined) {
        this.title = this.data.title;
      }
      if (this.data.body != undefined) {
        this.body = this.data.body;
      }
      if (this.data.actions != undefined) {
        this.actions = this.data.actions;
      }

      if (this.data.config != undefined) {
        this.config = this.data.config;
      }
    }

    this.dialogRef.disableClose = !this.config.allowAutoClose;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close(data?: any): void {
    this.dialogRef.close(data);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleActionClicked(event: MouseEvent, action: any): void {
    this.close({ event: event, action: action });
  }
}
